module.exports = __webpack_public_path__ + "assets/icon-installationType-portable.3cba18e5.svg";